import * as React from "react";
const IconL = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || "48"}
    height={props.size || "48"}
    
    viewBox="0 0 48 48"
    {...props}
  >
    <path
      
      fillRule="evenodd"
      d="M15 12a3 3 0 1 1 6 0v21h9a3 3 0 1 1 0 6H18a3 3 0 0 1-3-3zm3-1a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h12a1 1 0 1 0 0-2H20a1 1 0 0 1-1-1V12a1 1 0 0 0-1-1"
      clipRule="evenodd"
    />
  </svg>
);
export default IconL;
